// extracted by mini-css-extract-plugin
module.exports = {"circular":"legacy-base_circular__KPZzJ","layout":"legacy-base_layout__w56M0","divider":"legacy-base_divider__3iTox"};